import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateTimePicker from '@/components/Form/DateTimePicker'
import useAuthStore from '@/stores/useAuthStore'

interface Props {
    control: Control<any>
    disabled?: boolean
}

const TECH_DEPARTMENTS = ['TECHNOLOGY', 'DEVELOPMENT']

/**
 * TG dự tính bắt đầu xử lý ticket
 * Chỉ hiển thị cho nhân viên thuộc phòng TECHNOLOGY hoặc DEVELOPMENT
 * @param control - Control<any>
 * @param disabled - Disable input
 * @returns React.ReactNode
 */
const TicketTimeRepply: React.FC<Props> = ({ control, disabled }) => {
    const { t } = useTranslation()
    const { employee } = useAuthStore()

    // Chỉ hiển thị cho nhân viên thuộc phòng TECHNOLOGY hoặc DEVELOPMENT
    const isTechDepartment =
        employee?.department_name &&
        TECH_DEPARTMENTS.includes(employee.department_name)

    if (!isTechDepartment) return null

    return (
        <div>
            <DateTimePicker
                control={control}
                name="ticket_time_repply"
                label={t('ticket-time-repply')}
                required
                disabled={disabled}
            />
            <p className="text-xs text-gray-500 mt-1 italic">
                {t('ticket-time-repply-hint')}
            </p>
        </div>
    )
}

export default TicketTimeRepply
